import { atom } from 'jotai';
import { AuthState, User } from '../types/auth';
import { setAuthToken } from '../utils/api';
import { isTokenExpiredOrExpiringSoon } from '../utils/auth';

// Get initial state from localStorage
const token = localStorage.getItem('token');
const userStr = localStorage.getItem('user');
let user: User | null = null;
try {
  user = userStr ? JSON.parse(userStr) : null;
} catch (e) {
  localStorage.removeItem('user');
  console.debug('Error parsing user from localStorage', e);
}

// Check if token is valid
const isTokenValid = token && !isTokenExpiredOrExpiringSoon(token);
if (!isTokenValid && token) {
  // Clear invalid token
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  console.debug('Cleared expired token on initialization');
}

const initialState: AuthState = {
  isAuthenticated: !!isTokenValid && !!user,
  user: isTokenValid ? user : null,
  token: isTokenValid ? token : null,
};

export const authAtom = atom<AuthState>(initialState);

export const loginAtom = atom(
  (get) => get(authAtom),
  (_get, set, { token, user }: { token: string; user: User }) => {
    setAuthToken(token);
    localStorage.setItem('user', JSON.stringify(user));
    set(authAtom, {
      isAuthenticated: true,
      user,
      token,
    });
  }
);

export const logoutAtom = atom(
  (get) => get(authAtom),
  (_get, set) => {
    // Clear auth token from API utility
    setAuthToken(null);
    
    // Clear all auth-related items from localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    
    // Reset auth state
    set(authAtom, {
      isAuthenticated: false,
      user: null,
      token: null,
    });
  }
);

export const updateCurrentUserAtom = atom(
  (get) => get(authAtom),
  (_get, set, updatedUser: User) => {
    const currentAuth = _get(authAtom);
    if (currentAuth.isAuthenticated && currentAuth.user) {
      const updatedAuthState = {
        ...currentAuth,
        user: updatedUser,
      };
      
      // Update localStorage
      localStorage.setItem('user', JSON.stringify(updatedUser));
      
      // Update auth state
      set(authAtom, updatedAuthState);
    }
  }
); 